// @ts-nocheck

export type PropertyListIsEchoesLinked = typeof PropertyListIsEchoesLinked[keyof typeof PropertyListIsEchoesLinked];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PropertyListIsEchoesLinked = {
  true: 'true',
  false: 'false',
} as const;
